export default __webpack_public_path__ + "static/media/routes-gray.4dbfe5bd.svg";